import React from "react";
import "./Footer.css";
import Github from "../../assets/github.png";
import Instagram from "../../assets/instagram.png";
import LinkedIn from "../../assets/linkedin.png";
import Logo from "../../assets/logo.png";

const Footer = () => {
  return (
    // <div className="footer-container">
      <div className="footer">
        <div className="blur"></div>
        <div className="blur"></div>
        <hr />

      <div className="footer-container">
        <div className="social-media">
        <img src={Github} alt="" />
        <img src={Instagram} alt="" />
        <img src={LinkedIn} alt="" />
        </div>
      <div className="logo-f">
        <img src={Logo} alt="" />
      </div>

      </div>
    </div>
    // </div>
  );
};

export default Footer;
